/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Check_In_View_PricingInputs */

const en_check_in_view_pricing = /** @type {(inputs: Check_In_View_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View pricing`)
};

const es_check_in_view_pricing = /** @type {(inputs: Check_In_View_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver precios`)
};

/**
* | output |
* | --- |
* | "View pricing" |
*
* @param {Check_In_View_PricingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const check_in_view_pricing = /** @type {((inputs?: Check_In_View_PricingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Check_In_View_PricingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_check_in_view_pricing(inputs)
	return es_check_in_view_pricing(inputs)
});